<!-- <p>visits works!</p> -->


<!-- <div class="back-button-container" style="padding: 10px;">
  <button class="btn btn-secondary" (click)="goBack()">
    ← Back
  </button>
</div> -->


<!-- <p>folders works!</p> -->



<div class="layout-wrapper layout-content-navbar"  style="background-color: #F8F8FF;">
    <div class="layout-container">
  
      
  
  <!-- Menu -->
  
  <!-- <app-side-nav></app-side-nav> -->
  <!-- <app-folder-sidenav></app-folder-sidenav> -->
  
  <!-- side nav code starts hereeeeeeeeeeeeeeeeeeeeeeeeeeee -->
  
  
  
  <button class="menu-btn">
  &#9776; <!-- Unicode for the hamburger icon -->
  </button>
  
  <!-- Sidebar Card Wrapper -->
  <div class="sidebar-card">
  <!-- Sidebar -->
  <!-- <aside id="layout-menu" class="layout-menu menu-vertical menu bg-menu-theme" [ngClass]="{'show-nav': isSidebarVisible}"> -->
    <aside id="layout-menu" class="layout-menu menu-vertical menu bg-menu-theme">
    <div class="menu-inner-shadow"></div>
    <!-- <ul class="menu-inner py-1"> -->
    
  
          <div class="menu-item">
      
      <!-- <h5 class="menu-item" style="color: #6495ED">Subject Wise Folders  </h5>
  
      <br> -->
      
  <div class=" px-6 py-2 border-bottom d-flex justify-content-between align-items-center w-100">
  <h5 class="font-weight-bold m-0"style="color:black">Visit Folders</h5>
  </div>

  <!-- <div 
  class="px-6 py-2 border-bottom d-flex justify-content-center align-items-center w-100" 
  style="background-color: #f8f9fa;">
  <h5 
    class=" m-0" 
    style=" text-align:center;">
    Visit Folders
  </h5>
</div> -->

  
  
  <div class="menu-item">
  <a href="javascript:void(0);" class="menu-link d-flex justify-content-between align-items-center"
  style="cursor: default;"
  
  [ngClass]="{'highlighted': selectedFolder === 'VISIT 1 (DAY)'}"
  (click)="onFolderClick('VISIT 1 (DAY)')">
    <div>
      <i class="menu-icon tf-icons bx bx-layout"></i>
      <span>VISIT 1 (DAY)</span>
    </div>
  </a>
  
  <!-- Sub-items for Screening Visit -->
  <!-- <ul class="list-group mt-2 ps-4" *ngIf="isScreeningVisible">
    <li class="list-group-item border-0 p-1" 
     style="font-size: 15px;">1. Vital signs</li>
    <li class="list-group-item border-0 p-1"  style="font-size: 15px;">2. Body system</li>
  
    <li class="list-group-item border-0 p-1"  style="font-size: 15px;"  (click)="showForm('assessment')">3. Assessments</li>
  
    <li class="list-group-item border-0 p-1"  style="font-size: 15px;">4. Score index</li>
  
  
  </ul> -->


  <ul class="list-group mt-2 ps-4" *ngIf="isScreeningVisible">
    <li 
      class="list-group-item border-0 p-1"  
      style="font-size: 15px; cursor: default;" 
      [ngClass]="{'highlighted': selectedItem === 'Vital signs'}" 
      (click)="selectItem('Vital signs')">
      1. Vital signs
    </li>
    <li 
      class="list-group-item border-0 p-1"  
      style="font-size: 15px; cursor: default;" 
      [ngClass]="{'highlighted': selectedItem === 'Body system'}" 
      (click)="selectItem('Body system')">
      2. Body system
    </li>
    <li 
      class="list-group-item border-0 p-1"  
      style="font-size: 15px; cursor: default;" 
      [ngClass]="{'highlighted': selectedItem === 'Assessments'}" 
      (click)="selectItem('Assessments'); showForm('assessment')">
      3. Assessments
    </li>
    <li 
      class="list-group-item border-0 p-1"  
      style="font-size: 15px; cursor: default;" 
      [ngClass]="{'highlighted': selectedItem === 'Score index'}" 
      (click)="selectItem('Score index')">
      4. Score index
    </li>
  </ul>
  










  
  
  </div>
  
  
  
  
  
        
  
  
    </div>
  
        <div class="menu-item">
        <a href="javascript:void(0);" class="menu-link"  style="cursor: default;"
        
        [ngClass]="{'highlighted': selectedFolder === 'VISIT 2 (DAY)'}" 
        (click)="selectFolder('VISIT 2 (DAY)')"
        >
          <i class="menu-icon tf-icons bx bx-layout"></i>
          <div>VISIT 2 (DAY)</div>
        </a>
        
      </div>
  
  
  
  
      <div class="menu-item">
        <a href="javascript:void(0);" class="menu-link"  style="cursor: default;"
        
        [ngClass]="{'highlighted': selectedFolder === 'VISIT 3 (DAY)'}" 
        (click)="selectFolder('VISIT 3 (DAY)')"
        >
          <i class="menu-icon tf-icons bx bx-layout"></i>
          <div>VISIT 3 (DAY) </div>
        </a>
        
      </div>
  
    
  
  
  
  
     
  </aside>
  </div>
  
  
  
  <div class="container mt-4"> 
    <div class="card" style="height: 900px;">
      <div class="card-body">


        <!-- <button class="btn btn-primary" (click)="goBack()">
          ← Back
        </button> -->

        <div class="d-flex justify-content-end">
          <button type="button" class="btn custom-button"  (click)="goBack()">
            Back
          </button>
      </div>

        <br>
  
            <div class="new-card">
              <div >
  
            <!-- <table class="table new-table">
              <thead >
                <tr>
                 
                  <th>Study Name</th>
  
                  <th>Study ID</th>
  
                  
                  <th>Site Location</th>
  
                  <th>Subject ID</th>
                 
                </tr>
              </thead>
              <tbody>
              
                    <tr>
                  <td>{{ queryParams.studyId }}</td>
                  <td>{{ queryParams.name }}</td>
                 
                  <td>{{ queryParams.centers }}</td>
                  <td>{{ queryParams.subjectId }}</td>
               
               
                </tr>
              </tbody>
            </table> -->


            <div class="new-card" style="border: 2px solid #673AB7; border-radius: 8px; padding: 20px; background-color: #fff;">
              <div>
               
                <div class="card-content">

            <div class="card-content d-flex justify-content-between">
              
              <div class="text-center">
                <div><strong>ID</strong></div>
                <div>{{ queryParams.studyId }}</div>
              </div>
              <!-- Name -->
              <div class="text-center">
                <div><strong>Study Name</strong></div>
                <div>{{ queryParams.name }}</div>
              </div>
              <!-- Centers -->
              <div class="text-center">
                <div><strong>Site Location</strong></div>
                <div>{{ queryParams.centers }}</div>
              </div>
        

              <div class="text-center">
                <div><strong>Subject ID</strong></div>
                <div>{{ queryParams.subjectId }}</div>
              </div>

        
        
                      </div>

                      </div>
                      </div>
                      </div>





          </div>
        </div>
  
  
        <br>
  


        <!-- <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#createexampleModal">
            Add Subjects
          </button> -->

          <div class="d-flex justify-content-end">
            <button type="button" class="btn custom-button" data-bs-toggle="modal" data-bs-target="#createexampleModal">
                Add Visits
            </button>
        </div>

          <br>

  
          <!-- <br> -->
        <!-- <div class="px-6 py-2 border-bottom d-flex justify-content-between align-items-center w-100"> -->
          <!-- <div class="px-6 py-2 d-flex justify-content-between align-items-center w-100">
          <h5 class="m-0">Visits Details Here</h5>
        </div> -->


        <!-- <br> -->
        
<!-- form data starts hereeeeeeeeeeeee -->


<!-- Form for Screening 1 in a Card -->

<!-- <div class="new-card" *ngIf="selectedForm === 'assessment'" class="card mt-4">


    <div class="card-header d-flex justify-content-between align-items-center">
      <h5 class="m-0">Assessment Data</h5>
      <button type="button" class="btn btn-primary">Create Field</button>
    </div>
  
  
  
    <div >
  
  <table class="table new-table">
    <thead style="background-color: #007bff;">
      <tr>
        
        <th>S No</th>
  
        <th>Name</th>
  
        
        <th>Score</th>
  
       
       
      </tr>
    </thead>
    <tbody>
    
          <tr *ngFor="let student of data; let i = index">
        <td>{{ student.sr }}</td>
        <td>{{ student.name }}</td>
       
        <td>{{ queryParams.centers }}</td>
        <td> <input
          type="text"
          
          [(ngModel)]="student.score"
          placeholder="Enter score"
        /></td>
     
     
      </tr>
    </tbody>
  </table>
  </div>
  </div> -->
  



<!-- sample -->



  
<!-- <div class="container mt-4"> 
    <div class="card" style="height: 600px;">
      <div class="card-body"> -->
  
            <div class="new-card" *ngIf="selectedForm === 'assessment'">
              <div >




                <div class="mb-3">
                    <h6>Scores:</h6>
                    <ul class="list-inline">
                      <li class="list-inline-item" *ngFor="let legend of scoreLegend">
                        <!-- <span class="badge bg-primary">{{ legend.value }}: {{ legend.description }}</span> -->

                        <span class="badge" style="color: #DB7093">{{ legend.value }}: {{ legend.description }}</span>

                        
                      </li>
                    </ul>
                  </div>




                <div class="card-header d-flex justify-content-between align-items-center">
                    <h5 class="m-0">Assessment Data</h5>
                    <!-- <button type="button" class="btn btn-primary">Create Field</button> -->

                    <button type="button" class="btn custom-button" data-bs-toggle="modal" data-bs-target="#exampleModal">
                      Create Field
                    </button>

                  </div>
  
            <table class="table new-table">
              <!-- <thead style="background-color: #007bff;"> -->

                <thead style="background-color: #87CEEB;">

                <tr>
                    <th>S No</th>
  
                    <th>Name</th>
              
                    
                    <th>Score</th>
                 
                </tr>
              </thead>
              <tbody>
              
                <!-- <tr *ngFor="let user of studyDetails; let i = index">   -->
                    <tr *ngFor="let student of data; let i = index">
                        <td>{{ student.sr }}</td>
                        <td>{{ student.name }}</td>
                 
                  <!-- <td>{{ queryParams.centers }}</td>
                  <td>{{ queryParams.subjectId }}</td> -->

                  <td> <input
                    type="text"
                    class="form-control"
                    [(ngModel)]="student.score"
                    placeholder="Enter score"
                  /></td>

               
               
                </tr>
              </tbody>
            </table>
          </div>
        </div>
  
  












       
  











        <!-- form data ends hereeeeeeeee -->
  
        <!-- page ends brackets here -->
      </div>
    </div>
  </div>
  
  
  <!-- / Layout page -->
  </div>
  
  
  
  
  <!-- Overlay -->
  </div>
  
  



  

<!-- popup code starts here -->

<!-- Button trigger modal -->

  
  <!-- Modal -->
  <!-- <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"> -->

    <div class="modal fade" id="createexampleModal"  aria-labelledby="createexampleModalLabel" aria-hidden="true">

        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <!-- <h4 class="modal-title fs-5" id="exampleModalLabel">ADD FOLDER NAME HERE</h4> -->
              <h4 class="modal-title fs-5" id="createexampleModalLabel">ADD VISIT HERE</h4>
              <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
            </div>
    
            <br>
    
            <div class="modal-body">
                <!-- <div class="modal"> -->
              <!-- ... -->
    
              <!-- <form [formGroup]="subjectForm" (ngSubmit)="submitSubjectForm()"> -->
    
                <form [formGroup]="folderForm">
    
                <div class="form-group">
                  <!-- <label for="Name">Folder Name</label> -->

                  <label for="Name">Visit Name</label>

                  <input type="text" class="form-control" id="Name"  [(ngModel)]="Name" formControlName="Name">
                </div>
    
                <br>
    
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    <button type="button" class="btn custom-button">Submit</button>
                  </div>
    
                </form>
    
    
            </div>
            <!-- <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
              <button type="button" class="btn btn-primary">Submit</button>
            </div> -->
    
    
        <!-- </form> -->
    
          </div>
        </div>
      </div>






      <!-- create field popup code hereeeeeeeeeeeeeeeee -->



<!-- Button trigger modal -->
<!-- <button
  type="button"
  class="btn btn-primary"
  data-bs-toggle="modal"
  data-bs-target="#createexampleModal"
>
  Launch demo modal
</button> -->

<!-- Modal -->
<div
  class="modal fade"
  id="exampleModal"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Create Field Here</h5>
        <!-- <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button> -->
      </div>
      <div class="modal-body">
       

         <!-- Dropdown to Select Field Type -->
         <div class="form-group">
          <label for="fieldType">Select Field Type:</label>
          <select
            class="form-control"
            id="fieldType"
            [(ngModel)]="selectedFieldType"
          >
            <option value="string">String</option>
            <option value="numeric">Numeric</option>
            <option value="radio">Radio Button</option>
          </select>
        </div>

        <br />



        <!-- Conditional Rendering of Dynamic Field -->
        <div class="form-group" *ngIf="selectedFieldType === 'string'">
          <label for="stringInput">String Input:</label>
          <input
            type="text"
            id="stringInput"
            class="form-control"
            placeholder="Enter string value"
          />
        </div>

        <div class="form-group" *ngIf="selectedFieldType === 'numeric'">
          <label for="numericInput">Numeric Input:</label>
          <input
            type="number"
            id="numericInput"
            class="form-control"
            placeholder="Enter numeric value"
          />
        </div>

        <div class="form-group" *ngIf="selectedFieldType === 'radio'">
          <label>Radio Options:</label>
          <div>
            <input
              type="radio"
              id="radio1"
              name="radioGroup"
              value="Option 1"
            />
            <label for="radio1">YES</label>
          </div>
          <div>
            <input
              type="radio"
              id="radio2"
              name="radioGroup"
              value="Option 2"
            />
            <label for="radio2">NO</label>
          </div>
        </div>





      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          Close
        </button>
        <button type="button" class="btn custom-button">Save changes</button>
      </div>
    </div>
  </div>
</div>
